import React from 'react';
import './Legend.css';

const Legend = () => {
  return (
    <div className="legend">
      <h3>Legend</h3>
      <div className="legend-items">
        <div className="legend-item">
          <div className="legend-line legend-sop-route"></div>
          <span>SOP Routes</span>
        </div>
        <div className="legend-item">
          <div className="legend-line legend-vessel-run"></div>
          <span>Actual Routes</span>
        </div>
        <div className="legend-item">
          <div className="legend-line legend-selected-run"></div>
          <span>Selected Route</span>
        </div>
      </div>
    </div>
  );
};

export default Legend;